module.exports = __webpack_public_path__ + "img/loginLogo.e5aeeca8.jpg";